import { Record } from 'immutable';
import moment from 'moment';

const DEFAULT_STATE = {
  id: undefined,
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  authToken: undefined,
  createdAt: undefined,
};

class UserModel extends Record(DEFAULT_STATE) {
  static _name = 'Session::UserModel';

  get name() {
    return `${this.firstName} ${this.lastName}`;
  }

  get signedIn() {
    return !!this.authToken;
  }

  get day() {
    return moment().diff(this.createdAt, 'days') + 1;
  }
}

export default UserModel;
